module.exports = __webpack_public_path__ + "img/homebanner_a.daf0df44.jpg";